// extracted by mini-css-extract-plugin
module.exports = {"container":"CaseStudyCard_container__3bXw1","imageParallax":"CaseStudyCard_imageParallax__1b11I","arrow":"CaseStudyCard_arrow__nzY6G"};